module.exports = __webpack_public_path__ + "static/media/agile-scrum.87f29bee.png";